<template>
    <button v-if="this.disabled == true || this.loader == true" :aria-busy="this.loader" :style='this.style' v-bind:class="this.type" disabled class='btn disabled neue fsp14'>
        <span v-if="this.loader" class="button-loader" :style="{ width: `${this.loaderSize}px`, height: `${this.loaderSize}px` }" aria-hidden="true"></span>
        <template v-else>
            <slot name="currLogo"></slot>
            <i v-if='this.icon_i' class='item-i mr-1' :class='this.icon_i'></i>
            <span v-if="this.name" class="flex-grow-1 lh20">{{this.name}}</span>
            <slot></slot>
        </template>
    </button>
    <button v-else class='btn neue fsp14' :style='this.style' v-bind:class="this.type">
        <slot name="currLogo"></slot>
        <i v-if="this.icon_i.length > 1" class='item-i mr-1' :class='this.icon_i'></i>
        <span v-if="this.name" class="flex-grow-1 lh20">{{this.name}}</span>
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        name: [String],
        type: {
            type: String,
            default: 'btn-primary'
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loader: {
            type: Boolean,
            default: false,
        },
        loaderSize: {
            type: Number,
            default: 22,
        },
        icon_i: {
            type: String,
            default: '',
        },
        style: {
            type: String,
            default: '',
        }
    },
}
</script>

<style lang="scss" scoped>
.button-loader {
    border: 2px solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    display: block;
    animation: button-loader-spin 0.7s linear infinite;
}

@keyframes button-loader-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
